<div class="flex-row center-center preview">
  <span
    *ngIf="!image && name"
    class="avatar-random-color"
    [style.background-color]="color"
    [style.font-size.px]="fontSize"
    >{{ name | userAvatar }}</span
  >
  <img
    *ngIf="image"
    style="width: 100px; height: 100px"
    (error)="onImageError()"
    [src]="image"
    alt="avatar"
  />
</div>
